//import { vuexfireMutations, firestoreAction } from "vuexfire";

import router from "@/router";


const state = {
  modalOpen: false,
  specialDialog: false,
  drawer: false,
  user: null,
  loading: false,
  error: null,
  zoomLevel: 1,
  updateAvailable: false,

  profile: {},
  myevents: []
};

const actions = {
  zoomIn({ state, commit }, payload) {
    let newlevel = state.zoomLevel + 0.1;
    commit("setZoomLevel", newlevel);
  },
  zoomOut({ state, commit }, payload) {
    let newlevel = state.zoomLevel - 0.1;
    if(newlevel < 0.1) {
      newlevel = 0.1;
    }
    commit("setZoomLevel", newlevel);
  },  
  toggleDrawer({ state, commit }, payload) {
    commit("setDrawer", payload || !state.drawer);
  },
  showDrawer({  commit }, payload) {    
    console.log("store");
    console.log(payload);
    commit("setDrawer", payload);
  },  
  toggleLoading({ commit }, payload) {
    commit("setLoading", payload);
  },
  toggleModal({ state, commit }) {
    commit("closeModal", !state.modalOpen);
  },
  setError({ commit }, message) {
    commit("setError", message);
  },
  toggleSpecialDialog({ state, commit, dispatch }) {
    if (!state.specialDialog) {
      router.push(router.currentRoute.path + "/specialDialog");
    }
    dispatch("toggleModal");
    commit("toggleSpecialDialog", !state.specialDialog);
  },

  setUpdateAvailable({commit}) {
    commit("setUpdateAvailable", true);
  }  
};

const mutations = {
  setZoomLevel(state, level) {
    state.zoomLevel = level;
  },
  closeModal(state, modal = false) {
    state.modalOpen = modal;
  },
  toggleSpecialDialog(state, modal = false) {
    state.specialDialog = modal;
  },
  setDrawer(state, drawer = false) {
    state.drawer = drawer;
  },
  setUser(state, user) {
    state.user = user;
  },
  setLoading(state, loading = false) {
    state.loading = loading;
  },
  setError(state, message = null) {
    state.error = message;
  },
  setUpdateAvailable(state, payload) {
    state.updateAvailable = payload;
  }
};

const getters =  {
 
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
